var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ContextMenuAFY, icons, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
export var insurersView = [
    {
        active: true,
        icon: {
            icon: icons.GridView,
        },
        id: "1",
        name: "GridView",
    },
    {
        active: false,
        icon: {
            icon: icons.TableRows,
        },
        id: "2",
        name: "List",
    },
    {
        active: false,
        icon: {
            icon: icons.TableView,
        },
        id: "3",
        name: "tableView",
    },
];
export var buttonOptions = [
    {
        disabled: false,
        id: "1",
        name: "Modificar",
        divider: false,
        icon: {
            color: "#006ac6",
            icon: icons.Edit,
            size: sizesIcon.standard,
        },
    },
    {
        disabled: false,
        id: "2",
        name: "Eliminar",
        divider: false,
        icon: {
            color: "#006ac6",
            icon: icons.DeleteForever,
            size: sizesIcon.standard,
        },
    },
    {
        disabled: false,
        id: "3",
        name: "Asociar a producto",
        divider: false,
        icon: {
            color: "#006ac6",
            icon: icons.MenuBook,
            size: sizesIcon.standard,
        },
    },
];
export var dropdownCertTypeList = [
    {
        id: "TEMPLATE",
        name: "Template",
        value: "TEMPLATE",
        active: false,
    },
    {
        id: "ATTACHMENT",
        name: "Attachment",
        value: "ATTACHMENT",
        active: false,
    },
    {
        id: "QUICK_PRINT",
        name: "QuickPrint",
        value: "QUICK_PRINT",
        active: false,
    },
];
export var columns = function (handleClickContextMenu) {
    var columns = [
        {
            field: "actions",
            headerName: "Acciones",
            width: 150,
            renderCell: function (param) {
                return (_jsx("div", __assign({ style: { display: "flex" } }, { children: _jsx(ContextMenuAFY, { colorButton: "transparent", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: buttonOptions, onClickContextMenu: function (item) {
                            return handleClickContextMenu(item, param === null || param === void 0 ? void 0 : param.row);
                        }, sizeIcon: sizesIcon.standard }) })));
            },
        },
        {
            field: "title",
            headerName: "Titulo de certificado",
            width: 300,
        },
        {
            field: "type",
            headerName: "Tipo de certificado",
            width: 150,
        },
        {
            field: "physicalName",
            headerName: "URL documento",
            width: 250,
        },
        {
            field: "quickPrintable",
            headerName: "Imprimible",
            width: 150,
        },
    ];
    return columns;
};
export var defaultProjectItems = [];
export var defaultInsuranceItems = [
    {
        id: "",
        name: "",
        value: "",
    },
];
export var defaultOtherItems = [
    {
        id: "",
        name: "",
        value: "",
    },
];
